import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronLeft, faChevronRight, faImages, faCamera, faEye } from '@fortawesome/free-solid-svg-icons';

const Galeria = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Helper functions for category icons and names
  const getCategoryIcon = (categoryId) => {
    switch (categoryId) {
      case 'all': return '🏛️';
      case 'clientes': return '👥';
      case 'eventos': return '🎭';
      case 'platos': return '🍽️';
      case 'restaurante': return '🏢';
      default: return '📷';
    }
  };

  const getCategoryName = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.name : 'Otros';
  };
  
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const categories = [
    { id: 'all', name: 'Todas', count: 67 },
    { id: 'clientes', name: 'Clientes', count: 39 },
    { id: 'eventos', name: 'Eventos', count: 25 },
    { id: 'restaurante', name: 'Restaurante', count: 3 }
  ];

  const galleryImages = [
    // === CLIENTES REALES - SOLO FOTOS AUTÉNTICAS ===
    {
      id: 1,
      src: "/assets/images/clientes/comida-compartida-ambiente-acogedor.jpg",
      alt: "Cliente disfrutando cocktail en ADASTRA",
      category: "clientes",
      title: "Momentos de Alegría",
      description: "Nuestros clientes disfrutando de cócteles únicos en un ambiente acogedor"
    },
    {
      id: 2,
      src: "/assets/images/clientes/grupo-cena-social.jpg",
      alt: "Grupo de amigos cenando en ADASTRA",
      category: "clientes",
      title: "Cenas Grupales",
      description: "Experiencias compartidas con amigos en nuestro ambiente social"
    },
    {
      id: 3,
      src: "/assets/images/clientes/pareja-booth-intimo.jpg",
      alt: "Pareja en booth privado de ADASTRA",
      category: "clientes",
      title: "Momentos Íntimos",
      description: "Espacios privados perfectos para ocasiones especiales"
    },
    {
      id: 4,
      src: "/assets/images/clientes/mesa-grupal-ambiente.jpg",
      alt: "Mesa grupal disfrutando cena en ADASTRA",
      category: "clientes",
      title: "Celebraciones Familiares",
      description: "Reuniones familiares en un ambiente cálido y auténtico"
    },
    {
      id: 5,
      src: "/assets/images/clientes/pareja-romantica-sombrero.jpg",
      alt: "Pareja romántica en ADASTRA",
      category: "clientes",
      title: "Cenas Románticas",
      description: "El lugar perfecto para momentos especiales en pareja"
    },
    {
      id: 7,
      src: "/assets/images/clientes/cocktail-artesanal-flor.jpg",
      alt: "Cliente disfrutando cóctel artesanal con flor",
      category: "clientes",
      title: "Cócteles Únicos",
      description: "Bebidas artesanales preparadas con atención al detalle"
    },
    {
      id: 8,
      src: "/assets/images/clientes/grupo-sonriente-ambiente.jpg",
      alt: "Grupo de clientes sonrientes en ambiente social",
      category: "clientes",
      title: "Momentos de Felicidad",
      description: "La alegría y calidez que caracteriza nuestro ambiente"
    },
    {
      id: 9,
      src: "/assets/images/clientes/celebracion-familiar-ramo.jpg",
      alt: "Celebración familiar con ramo de flores",
      category: "clientes",
      title: "Celebraciones Especiales",
      description: "Momentos únicos para celebrar ocasiones importantes"
    },
    {
      id: 10,
      src: "/assets/images/clientes/cliente-relajada-barra.jpg",
      alt: "Cliente relajada disfrutando en la barra",
      category: "clientes",
      title: "Experiencia en la Barra",
      description: "Ambiente acogedor para disfrutar en nuestra barra profesional"
    },
    {
      id: 11,
      src: "/assets/images/clientes/brindis-ron-selfie.jpg",
      alt: "Cliente brindando con ron premium",
      category: "clientes",
      title: "Brindis Especial",
      description: "Momentos únicos con nuestros rones y licores premium"
    },
    {
      id: 12,
      src: "/assets/images/clientes/vista-aerea-salon-completo.jpg",  
      alt: "Vista aérea del salón lleno de clientes",
      category: "clientes",
      title: "Salón Completo",
      description: "El ambiente vibrante y acogedor que caracteriza nuestro restaurante"
    },
    {
      id: 13,
      src: "/assets/images/clientes/mesa-redonda-mural-fondo.jpg",
      alt: "Mesa redonda con el hermoso mural de fondo",
      category: "clientes",
      title: "Arte y Convivencia",
      description: "Nuestro icónico mural como telón de fondo de grandes momentos"
    },
    {
      id: 14,
      src: "/assets/images/clientes/cliente-booth-sonriente.jpg",
      alt: "Cliente sonriente en booth privado",
      category: "clientes",
      title: "Espacios Íntimos",
      description: "Booths privados para una experiencia más personal"
    },
    {
      id: 15,
      src: "/assets/images/clientes/cliente-joven-bebida.jpg",
      alt: "Cliente joven disfrutando bebida artesanal",
      category: "clientes",
      title: "Nueva Generación",
      description: "Atrayendo a clientes de todas las edades con nuestra propuesta única"
    },
    {
      id: 16,
      src: "/assets/images/clientes/paella-familiar-tradicional.jpg",
      alt: "Familia disfrutando paella tradicional",
      category: "clientes",
      title: "Paella Familiar",
      description: "Nuestros platos tradicionales compartidos en familia"
    },
    {
      id: 17,
      src: "/assets/images/clientes/familia-booth-plantas-tropicales.jpg",
      alt: "Familia cenando en booth con decoración tropical",
      category: "clientes",
      title: "Ambiente Tropical",
      description: "Decoración natural que transporta al Caribe en cada rincón"
    },
    {
      id: 18,
      src: "/assets/images/clientes/grupo-mujeres-terraza-verde.jpg",
      alt: "Grupo de amigas en terraza con vegetación",
      category: "clientes",
      title: "Terraza Verde",
      description: "Espacio exterior rodeado de naturaleza para momentos especiales"
    },
    {
      id: 19,
      src: "/assets/images/clientes/terraza-exterior-comensales.jpg",
      alt: "Vista general de la terraza con múltiples comensales",
      category: "clientes",
      title: "Terraza Completa",
      description: "Nuestro popular espacio al aire libre siempre lleno de vida"
    },
    {
      id: 20,
      src: "/assets/images/clientes/brindis-celebracion-grupal.jpg",
      alt: "Grupo celebrando con brindis especial",
      category: "clientes",
      title: "Celebraciones Grupales",
      description: "Momentos de alegría y celebración que hacen únicos nuestros encuentros"
    },
    {
      id: 21,
      src: "/assets/images/clientes/terraza-vista-aerea-detalle.jpg",
      alt: "Vista aérea detallada de la terraza tropical",
      category: "clientes",
      title: "Oasis Tropical",
      description: "Nuestra terraza única con vegetación exuberante y diseño caribeño"
    },
    {
      id: 22,
      src: "/assets/images/clientes/mesa-compartida-platos-tradicionales.jpg",
      alt: "Mesa compartida con platos tradicionales cubanos",
      category: "clientes",
      title: "Tradición Compartida",
      description: "La auténtica experiencia cubana vivida en familia"
    },
    {
      id: 23,
      src: "/assets/images/clientes/amigas-brindis-terraza-tropical.jpg",
      alt: "Amigas brindando en la terraza tropical",
      category: "clientes",
      title: "Amistad y Naturaleza",
      description: "Encuentros especiales rodeados de la belleza natural de nuestra terraza"
    },
    {
      id: 24,
      src: "/assets/images/clientes/terraza-tropical-vegetacion.jpg",
      alt: "Terraza con exuberante vegetación tropical",
      category: "clientes",
      title: "Jardín Caribeño",
      description: "Un escape tropical en el corazón de La Habana"
    },
    {
      id: 25,
      src: "/assets/images/clientes/comida-compartida-ambiente-acogedor.jpg",
      alt: "Comida compartida en ambiente acogedor",
      category: "clientes",
      title: "Momentos que Unen",
      description: "La experiencia gastronómica que crea vínculos y memorias especiales"
    },
    {
      id: 44,
      src: "/assets/images/clientes/familia-ninos-coloreando-terraza.jpg",
      alt: "Familia con niños coloreando en la terraza",
      category: "clientes",
      title: "Experiencia Familiar",
      description: "Un lugar acogedor donde las familias crean momentos especiales juntas"
    },
    {
      id: 45,
      src: "/assets/images/clientes/cliente-feliz-coctel-amarillo.jpg",
      alt: "Cliente feliz disfrutando cóctel amarillo y comida",
      category: "clientes",
      title: "Alegría Auténtica",
      description: "La satisfacción genuina de nuestros clientes con cada experiencia"
    },
    {
      id: 46,
      src: "/assets/images/clientes/selfie-mural-vestido-verde.jpg",
      alt: "Cliente tomándose selfie con el icónico mural de fondo",
      category: "clientes",
      title: "Arte y Estilo",
      description: "Nuestro famoso mural como telón de fondo de momentos memorables"
    },
    {
      id: 47,
      src: "/assets/images/clientes/pareja-cena-romantica-aceite.jpg",
      alt: "Pareja disfrutando cena romántica íntima",
      category: "clientes",
      title: "Romance Perfecto",
      description: "Cenas íntimas con atención a cada detalle para momentos especiales"
    },
    {
      id: 48,
      src: "/assets/images/clientes/hombre-selfie-terraza-tropical.jpg",
      alt: "Cliente en selfie en la exuberante terraza tropical",
      category: "clientes",
      title: "Paraíso Tropical",
      description: "Nuestro oasis verde que transporta a cada visitante al Caribe auténtico"
    },
    {
      id: 49,
      src: "/assets/images/clientes/servicio-personalizado-interior.jpg",
      alt: "Personal de ADASTRA brindando servicio personalizado a clientes",
      category: "clientes",
      title: "Servicio de Excelencia",
      description: "Atención personalizada que hace especial cada visita a ADASTRA"
    },
    {
      id: 50,
      src: "/assets/images/clientes/amigas-brindis-cocteles-rojos.jpg",
      alt: "Amigas brindando con cócteles rojos especiales",
      category: "clientes",
      title: "Cócteles Artesanales",
      description: "Bebidas únicas preparadas con maestría para celebrar momentos especiales"
    },
    {
      id: 51,
      src: "/assets/images/clientes/grupo-grande-mesa-redonda-sombrero.jpg",
      alt: "Grupo grande celebrando alrededor de mesa redonda",
      category: "clientes",
      title: "Celebraciones Grandes",
      description: "Espacio perfecto para reunir a grupos grandes en un ambiente festivo"
    },
    {
      id: 52,
      src: "/assets/images/clientes/barra-licores-iluminada-clientes.jpg",
      alt: "Clientes en la impresionante barra de licores iluminada",
      category: "clientes",
      title: "Barra Espectacular",
      description: "Nuestra famosa barra con colección premium de licores y ambiente único"
    },
    {
      id: 53,
      src: "/assets/images/clientes/entrada-restaurante-servicio-exterior.jpg",
      alt: "Entrada del restaurante con servicio atendiendo clientes",
      category: "clientes",
      title: "Bienvenida Cálida",
      description: "Desde la entrada, cada cliente recibe la calidez característica de ADASTRA"
    },
    {
      id: 54,
      src: "/assets/images/clientes/pareja-terraza-tropical-romantica.jpg",
      alt: "Pareja disfrutando momento romántico en terraza tropical",
      category: "clientes",
      title: "Romance Tropical",
      description: "La terraza exuberante como escenario perfecto para momentos íntimos"
    },
    {
      id: 55,
      src: "/assets/images/clientes/clientes-tradicion-afro-barra-licores.jpg",
      alt: "Clientes con vestimenta tradicional afrocubana en la barra",
      category: "clientes",
      title: "Diversidad Cultural",
      description: "ADASTRA celebra la rica diversidad cultural de Cuba y sus tradiciones"
    },
    {
      id: 56,
      src: "/assets/images/clientes/grupo-amigas-terraza-tropical-dia.jpg",
      alt: "Grupo de amigas disfrutando almuerzo en terraza durante el día",
      category: "clientes",
      title: "Amistad y Naturaleza",
      description: "Reuniones especiales rodeadas de la belleza natural de nuestra terraza"
    },
    {
      id: 57,
      src: "/assets/images/clientes/doble-cita-parejas-terraza-sombreros.jpg",
      alt: "Doble cita de parejas en terraza con sombreros estilo tropical",
      category: "clientes",
      title: "Estilo Caribeño",
      description: "El ambiente tropical invita a disfrutar con estilo caribeño auténtico"
    },
    {
      id: 58,
      src: "/assets/images/clientes/conversacion-intima-terraza-vegetacion.jpg",
      alt: "Pareja en conversación íntima rodeada de vegetación tropical",
      category: "clientes",
      title: "Intimidad Natural",
      description: "Espacios privados en medio de un oasis verde para conversaciones especiales"
    },

    // === RESTAURANTE REALES ===
    {
      id: 26,
      src: "/assets/images/restaurant/hero-1.jpg",
      alt: "Interior principal de ADASTRA Restaurant",
      category: "restaurante",
      title: "Sala Principal",
      description: "Ambiente moderno con mural artístico y decoración elegante"
    },
    {
      id: 27,
      src: "/assets/images/restaurant/hero-2.jpg",
      alt: "Vista alternativa del interior de ADASTRA",
      category: "restaurante",
      title: "Ambiente Acogedor",
      description: "Iluminación cálida y espacios cómodos para toda experiencia"
    },
    {
      id: 400,
      src: "/assets/images/restaurant/Fachada.JPG",
      alt: "Fachada exterior de ADASTRA Restaurant",
      category: "restaurante",
      title: "Entrada Principal",
      description: "La elegante entrada de ADASTRA en el corazón de La Habana"
    },

    // === PLATOS GOURMET - FOTOGRAFÍAS REALES DEL MENÚ ADASTRA ===
    
    // Primera Tanda (17:11) - Postres y Cócteles
    // Tercera Tanda (17:16) - Mesas Completas
    

    // === EVENTOS REALES - MÚSICA EN VIVO Y ENTRETENIMIENTO ===
    {
      id: 38,
      src: "/assets/images/eventos/musica-en-vivo-cantante-rastas.jpg",
      alt: "Música en vivo con cantante y banda completa",
      category: "eventos",
      title: "Noches Musicales",
      description: "Artistas locales ofrecen experiencias musicales auténticas en vivo"
    },
    {
      id: 39,
      src: "/assets/images/eventos/pareja-bailando-salsa-interior.jpg",
      alt: "Pareja bailando salsa en el interior del restaurante",
      category: "eventos",
      title: "Baile y Diversión",
      description: "El ambiente perfecto para disfrutar y bailar música latina"
    },
    {
      id: 40,
      src: "/assets/images/eventos/cantante-femenina-turbante-rastas.jpg",
      alt: "Cantante femenina con turbante interpretando música afrocubana",
      category: "eventos",
      title: "Tradición Afrocubana",
      description: "Celebración de la rica herencia musical afrocubana"
    },
    {
      id: 41,
      src: "/assets/images/eventos/saxofonista-jazz-terraza-tropical.jpg",
      alt: "Saxofonista tocando jazz en la terraza tropical",
      category: "eventos",
      title: "Jazz en la Terraza",
      description: "Música instrumental en el hermoso ambiente tropical"
    },
    {
      id: 42,
      src: "/assets/images/eventos/percusionista-tambores-gafas-rojas.jpg",
      alt: "Percusionista tocando tambores tradicionales",
      category: "eventos",
      title: "Ritmos Cubanos",
      description: "Los auténticos ritmos cubanos que dan vida a cada noche"
    },
    {
      id: 43,
      src: "/assets/images/eventos/celebracion-familiar-gran-grupo-mural.jpg",
      alt: "Gran celebración familiar con más de 15 personas",
      category: "eventos",
      title: "Celebraciones Familiares Grandes",
      description: "Espacio y servicio para reunir a toda la familia en ocasiones especiales"
    },
    {
      id: 44,
      src: "/assets/images/eventos/saxofonista-escalera-interior-unico.jpg",
      alt: "Saxofonista tocando en la escalera del interior del restaurante",
      category: "eventos",
      title: "Música en Espacios Únicos",
      description: "Cada rincón de ADASTRA se convierte en un escenario para el arte"
    },
    {
      id: 45,
      src: "/assets/images/eventos/ambiente-nocturno-alegria-mural-fondo.jpg",
      alt: "Ambiente nocturno lleno de alegría con el mural de fondo",
      category: "eventos",
      title: "Noches de Alegría",
      description: "El ambiente perfecto donde la diversión y el arte se encuentran"
    },
    {
      id: 46,
      src: "/assets/images/eventos/mujer-riendo-alegria-vino-celebracion.jpg",
      alt: "Mujer celebrando con alegría auténtica y copa de vino",
      category: "eventos",
      title: "Momentos de Pura Alegría",
      description: "La felicidad genuina que caracteriza cada celebración en ADASTRA"
    },
    {
      id: 47,
      src: "/assets/images/eventos/bartenders-preparando-cocteles-barra.jpg",
      alt: "Bartenders profesionales preparando cócteles en la barra",
      category: "eventos",
      title: "Arte de la Coctelería",
      description: "Maestros cocteleros creando experiencias únicas en cada bebida"
    },
    {
      id: 48,
      src: "/assets/images/eventos/servicio-personalizado-paella-terraza.jpg",
      alt: "Servicio personalizado sirviendo paella en la terraza tropical",
      category: "eventos",
      title: "Servicio de Excelencia",
      description: "Atención personalizada con platos especiales en nuestra terraza única"
    },
    {
      id: 49,
      src: "/assets/images/eventos/dj-musica-electronica-laptop.jpg",
      alt: "DJ con equipos modernos y laptop creando ambiente musical",
      category: "eventos",
      title: "Música Moderna",
      description: "Fusión de tecnología moderna con ambiente tradicional cubano"
    },
    {
      id: 50,
      src: "/assets/images/eventos/saxofonista-urbano-tatuajes-gorra.jpg",
      alt: "Saxofonista urbano con tatuajes y estilo contemporáneo",
      category: "eventos",
      title: "Jazz Urbano",
      description: "Nueva generación de músicos fusionando tradición con estilo urbano"
    },
    {
      id: 51,
      src: "/assets/images/eventos/bartenders-maestros-cocteleria-profesional.jpg",
      alt: "Maestros bartenders trabajando con precisión en la barra iluminada",
      category: "eventos",
      title: "Maestría en Coctelería",
      description: "Técnica profesional y creatividad en cada cóctel artesanal"
    },
    {
      id: 52,
      src: "/assets/images/eventos/vista-aerea-arquitectura-espectacular.jpg",
      alt: "Vista aérea espectacular del restaurante mostrando arquitectura única",
      category: "eventos",
      title: "Arquitectura Espectacular",
      description: "La belleza arquitectónica y diseño único de ADASTRA desde una perspectiva aérea"
    },
    {
      id: 53,
      src: "/assets/images/eventos/vista-aerea-banda-completa-terraza.jpg",
      alt: "Vista aérea de banda completa con batería, guitarra y cantante en terraza",
      category: "eventos",
      title: "Banda Completa en Vivo",
      description: "Espectáculo musical profesional con banda completa en nuestra terraza única"
    },
    {
      id: 54,
      src: "/assets/images/eventos/servicio-gourmet-terraza-tropical.jpg",
      alt: "Servicio gourmet personalizado en la terraza tropical",
      category: "eventos",
      title: "Servicio Gourmet",
      description: "Atención personalizada de alta calidad en nuestro ambiente tropical único"
    },
    {
      id: 55,
      src: "/assets/images/eventos/cantante-afrocubana-percusion-vestido-colorido.jpg",
      alt: "Cantante afrocubana con percusión y vestido tradicional colorido",
      category: "eventos",
      title: "Tradición Afrocubana Viva",
      description: "Música y tradición afrocubana auténtica con vestimenta tradicional vibrante"
    },
    {
      id: 56,
      src: "/assets/images/eventos/bartender-mojitos-multiples-barra-profesional.jpg",
      alt: "Bartender preparando múltiples mojitos con técnica profesional en la barra",
      category: "eventos",
      title: "Maestría en Mojitos",
      description: "Técnica profesional creando múltiples mojitos perfectos simultáneamente"
    },
    {
      id: 57,
      src: "/assets/images/eventos/duo-cantantes-hombre-mujer-emocional.jpg",
      alt: "Dúo de cantantes, hombre con rastas y mujer con vestido amarillo, interpretación emotiva",
      category: "eventos",
      title: "Dúo Musical Emotivo",
      description: "Interpretación musical emotiva de dúo profesional creando momentos inolvidables"
    },
    {
      id: 58,
      src: "/assets/images/eventos/grupo-joven-moderno-barra-licores.jpg",
      alt: "Grupo de jóvenes modernos disfrutando en la barra de licores iluminada",
      category: "eventos",
      title: "Nueva Generación",
      description: "ADASTRA atrae a jóvenes modernos que aprecian la calidad y el ambiente único"
    },
    {
      id: 59,
      src: "/assets/images/eventos/baile-salsa-vestido-rojo-interior.jpg",
      alt: "Pareja bailando salsa apasionadamente, mujer con vestido rojo en el interior",
      category: "eventos",
      title: "Pasión de la Salsa",
      description: "El baile auténtico cubano cobra vida en nuestro ambiente cálido"
    },
    {
      id: 60,
      src: "/assets/images/eventos/reunion-multigeneracional-mural-iconico.jpg",
      alt: "Reunión multigeneracional alrededor del icónico mural de la mujer con plantas",
      category: "eventos",
      title: "Encuentro Multigeneracional",
      description: "ADASTRA une generaciones alrededor de nuestro arte y tradición"
    },
    {
      id: 61,
      src: "/assets/images/eventos/selfie-espontaneo-ambiente-autentico.jpg",
      alt: "Cliente tomándose selfie espontáneo en el ambiente auténtico del restaurante",
      category: "eventos",
      title: "Momentos Espontáneos",
      description: "La autenticidad de ADASTRA genera momentos naturales e inolvidables"
    },
    {
      id: 62,
      src: "/assets/images/eventos/propietario-cliente-feliz-adastra.jpg",
      alt: "Propietario de ADASTRA con cliente feliz mostrando la calidez del servicio",
      category: "eventos",
      title: "Hospitalidad Auténtica",
      description: "La calidez personal del propietario hace única cada experiencia en ADASTRA"
    }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const openModal = (image, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    const nextIndex = (currentImageIndex + 1) % filteredImages.length;
    setCurrentImageIndex(nextIndex);
    setSelectedImage(filteredImages[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = (currentImageIndex - 1 + filteredImages.length) % filteredImages.length;
    setCurrentImageIndex(prevIndex);
    setSelectedImage(filteredImages[prevIndex]);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentImageIndex, filteredImages]);

  return (
    <div className="page-transition">
      {/* Hero Section - Minimalist Restaurant Gallery Design */}
      <section className="relative h-screen overflow-hidden">
        
        {/* Hero Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Entrada%20con%20jarron%20y%20colecion.JPG"
            alt="Interior elegante de ADASTRA Restaurant con vista panorámica"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white max-w-4xl mx-auto px-6">
            
            {/* Main Title */}
            <h1 className="font-sans text-5xl md:text-7xl font-light leading-tight tracking-wide mb-6">
              <span className="text-green-400 font-normal italic">Galería</span>
            </h1>
            
            {/* Subtitle */}
            <p className="font-sans text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-8">
              Descubre la esencia visual de nuestra experiencia gastronómica cubana auténtica
            </p>
            
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="w-px h-16 bg-white/30 relative">
            <div className="absolute bottom-0 w-px h-8 bg-white animate-pulse"></div>
          </div>
        </div>
        
      </section>

      {/* Gallery Stats - Clean Design */}
      <section className="bg-white py-16">
        <div className="container-custom max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            <div className="p-8 text-center">
              <div className="font-sans text-4xl font-extralight text-gray-900 mb-3">67<span className="text-green-600">+</span></div>
              <div className="h-px w-8 bg-gray-300 mx-auto mb-3"></div>
              <div className="font-sans text-sm font-medium text-gray-500 uppercase tracking-wider">Momentos Capturados</div>
            </div>
            
            <div className="p-8 text-center">
              <div className="font-sans text-4xl font-extralight text-gray-900 mb-3">25<span className="text-green-600">+</span></div>
              <div className="h-px w-8 bg-gray-300 mx-auto mb-3"></div>
              <div className="font-sans text-sm font-medium text-gray-500 uppercase tracking-wider">Eventos Especiales</div>
            </div>
            
            <div className="p-8 text-center">
              <div className="font-sans text-4xl font-extralight text-gray-900 mb-3">39<span className="text-green-600">+</span></div>
              <div className="h-px w-8 bg-gray-300 mx-auto mb-3"></div>
              <div className="font-sans text-sm font-medium text-gray-500 uppercase tracking-wider">Clientes Felices</div>
            </div>
            
          </div>
        </div>
      </section>

      {/* Filter Section - Estilo Menu */}
      <section id="gallery-section" className="bg-white">
        <div className="container-custom max-w-7xl mx-auto px-6 py-20">
          
          {/* Section Header - Estilo Menu */}
          <div className="text-center mb-16">
            <h2 className="font-sans text-5xl md:text-6xl font-light text-gray-900 leading-tight mb-6">
              Explora nuestros <span className="text-green-600 font-normal italic">momentos</span>
            </h2>
            <p className="font-sans text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Filtra por categoría para descubrir diferentes aspectos de la experiencia ADASTRA
            </p>
          </div>

          {/* Filters Bar - Estilo Menu */}
          <div className="bg-white rounded-2xl p-8 mb-12 shadow-lg border border-gray-200">
            <div className="flex flex-col lg:flex-row gap-8">
              
              {/* Category Filters */}
              <div className="flex-1">
                <h3 className="font-sans text-lg font-semibold mb-4 text-gray-800 flex items-center space-x-2">
                  <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                  </svg>
                  <span>Categorías</span>
                </h3>
                <div className="flex flex-wrap gap-3">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`flex items-center space-x-2 px-5 py-3 rounded-lg font-medium transition-all duration-300 ${
                        selectedCategory === category.id
                          ? 'bg-black text-white shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      <span>{category.name}</span>
                      <span className="text-xs opacity-60">({category.count})</span>
                    </button>
                  ))}
                </div>
              </div>

            </div>
          </div>

          {/* Gallery Grid - Estilo Menu */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredImages.map((image, index) => (
              <div
                key={image.id}
                className={`relative overflow-hidden group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-200 ${
                  index % 12 === 0 ? 'lg:col-span-2 lg:row-span-2' : 
                  index % 8 === 0 ? 'md:col-span-2' : ''
                }`}
                onClick={() => openModal(image, index)}
                style={{animationDelay: `${index * 0.05}s`}}
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                      index % 12 === 0 ? 'aspect-[4/3]' : 
                      index % 8 === 0 ? 'aspect-[2/1]' : 'aspect-square'
                    }`}
                  />
                </div>
                
                {/* Category Badge - Estilo Menu */}
                <div className="absolute top-3 left-3">
                  <span className="bg-black text-white px-2 py-1 rounded-md text-xs font-medium">
                    {getCategoryName(image.category)}
                  </span>
                </div>

                {/* Overlay - Estilo Menu */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-gradient-to-t from-black/80 to-transparent">
                    <h3 className="font-sans text-lg font-bold mb-1">{image.title}</h3>
                    <p className="font-sans text-sm text-gray-200 opacity-90 line-clamp-2">{image.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* No images found - Estilo Menu */}
          {filteredImages.length === 0 && (
            <div className="text-center py-16">
              <div className="bg-white rounded-3xl p-10 max-w-md mx-auto shadow-xl border border-gray-200">
                <svg className="w-16 h-16 mx-auto text-gray-300 mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <h3 className="font-sans text-2xl font-bold mb-4 text-gray-800">No hay imágenes disponibles</h3>
                <p className="text-gray-600 mb-8">
                  No se encontraron imágenes con los filtros seleccionados.
                </p>
                <button
                  onClick={() => setSelectedCategory('all')}
                  className="bg-black hover:bg-gray-800 text-white py-3 px-6 rounded-lg font-semibold transition-all duration-300"
                >
                  Ver todas las imágenes
                </button>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* Call to Action Section - Estilo Menu */}
      <section className="bg-gray-50 py-20 border-t border-gray-200">
        <div className="container-custom max-w-4xl mx-auto px-6 text-center">
          
          <h2 className="font-sans text-4xl md:text-5xl font-light text-gray-900 leading-tight mb-6">
            ¿Te gusta lo que <span className="text-black font-normal italic">ves?</span>
          </h2>
          
          <p className="font-sans text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed mb-12">
            Ven y vive la experiencia ADASTRA en persona. Cada imagen cobra vida 
            cuando pruebas nuestros sabores auténticos.
          </p>
          
          {/* CTA Buttons - Estilo Menu */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/reservas" 
              className="bg-black hover:bg-gray-800 text-white py-4 px-8 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg flex items-center justify-center space-x-2"
            >
              <span>RESERVAR MESA</span>
              <span>→</span>
            </Link>
            <Link 
              to="/menu" 
              className="bg-gray-100 hover:bg-gray-200 text-gray-700 py-4 px-8 rounded-lg font-semibold transition-all duration-300 flex items-center justify-center space-x-2 border border-gray-200"
            >
              <span>VER MENÚ</span>
              <span>→</span>
            </Link>
          </div>
          
        </div>
      </section>

      {/* Modal Lightbox */}
      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div 
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={closeModal}
          ></div>
          
          {/* Modal Content */}
          <div className="relative max-w-6xl max-h-[90vh] mx-4">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-10"
            >
              <FontAwesomeIcon icon={faTimes} className="text-2xl" />
            </button>
            
            {/* Navigation Buttons */}
            <button
              onClick={prevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors z-10"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            
            <button
              onClick={nextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors z-10"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
            
            {/* Image */}
            <div className="relative bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[70vh] object-contain"
              />
              
              {/* Image Info */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <h3 className="font-sans text-2xl font-medium text-white mb-2">
                  {selectedImage.title}
                </h3>
                <p className="font-sans text-gray-200 leading-relaxed">
                  {selectedImage.description}
                </p>
                
                {/* Image Counter */}
                <div className="mt-4 text-sm text-gray-300">
                  {currentImageIndex + 1} de {filteredImages.length}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Galeria;